<div class="layout-footer">
    <div class="footer-start">
        <img [src]="'assets/plateformebeneficiaire/images/logo.png'" alt="logo" />
        <span class="app-name">{{ 'application_name' | translate }}</span>
    </div>
    <div class="footer-end">
        <span>© SSTRN TECHNOLOGIES</span>
    </div>
</div>
